import script from "./MoleculePagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoleculePagination.vue?vue&type=script&setup=true&lang=ts"

import "./MoleculePagination.vue?vue&type=style&index=0&id=5b08722e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b08722e"]])

export default __exports__